import { render, staticRenderFns } from "./Nav.vue?vue&type=template&id=b64e5018&scoped=true"
var script = {}
import style0 from "./Nav.vue?vue&type=style&index=0&id=b64e5018&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64e5018",
  null
  
)

export default component.exports